<template>
  <div>
    <v-card>
      <v-toolbar card prominent class="on-top">
        <v-toolbar-title>Danh sách vùng giới hạn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="SET_ADD_GEOFENCE_STATE(true)">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <v-list three-line>
          <template v-for="(item, index) in geofences">
            <v-list-tile
              avatar
              :key="item.id"
              :color="getSelectedGeofenceColor(item)"
              @click="SET_SELECTED_GEOFENCE(item)"
              @contextmenu.prevent="openContextMenu($event, item)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{item.name}}</v-list-tile-title>
                <v-list-tile-sub-title>Bán kính: {{item.radius}}m</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-icon slot="activator" color="grey">more_vert</v-icon>
                    <v-list>
                      <v-list-tile @click="SET_EDIT_GEOFENCE_STATE(true)">
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">edit</v-icon>
                          <span>Chỉnh sửa</span>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="deleteGeofenceDialog = true">
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">delete_forever</v-icon>
                          <span>Xóa</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider :key="index"></v-divider>
          </template>
        </v-list>
      </vue-perfect-scrollbar>
    </v-card>
    <div class="text-xs-center">
      <v-dialog v-model="deleteGeofenceDialog" width="360">
        <v-card>
          <v-card-title class="headline">Xóa vùng giới hạn</v-card-title>
          <v-card-text>Thao tác này sẽ không thể phục hồi, bạn có chắc chắn muốn xóa ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="deleteGeofenceDialog = false">Hủy</v-btn>
            <v-btn color="red" flat="flat" :loading="isLoading" @click="deleteSubmit()">Xóa</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Context Menu -->
      <vue-context ref="contextMenu">
        <v-list>
          <v-list-tile @click="SET_EDIT_GEOFENCE_STATE(true)">
            <v-list-tile-title>
              <v-icon class="menu-item-icon">edit</v-icon>
              <span>Chỉnh sửa</span>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="deleteGeofenceDialog = true">
            <v-list-tile-title>
              <v-icon class="menu-item-icon">delete_forever</v-icon>
              <span>Xóa</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </vue-context>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { VueContext } from 'vue-context';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'geofence-list',
  components: { VuePerfectScrollbar, VueContext },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 160
      },
      deleteGeofenceDialog: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['geofences', 'selectedGeofence'])
  },
  mounted () {
    this.SET_ADD_GEOFENCE_STATE(false);
    this.getGeofences();
  },
  methods: {
    ...mapActions(['getGeofences', 'deleteGeofence']),
    ...mapMutations([
      'SET_SELECTED_GEOFENCE',
      'SET_ADD_GEOFENCE_STATE',
      'SET_EDIT_GEOFENCE_STATE',
      'DELETE_GEOFENCE'
    ]),
    getSelectedGeofenceColor (fence) {
      if (this.selectedGeofence && fence.id === this.selectedGeofence.id) {
        return 'purple';
      } else {
        return 'black';
      }
    },
    deleteSubmit () {
      const data = {
        ids: [this.selectedGeofence.id]
      };
      this.isLoading = true;
      this.deleteGeofence(data)
        .then(_ => {
          this.isLoading = false;
          this.deleteGeofenceDialog = false;
          this.DELETE_GEOFENCE(this.selectedGeofence);
          window.getApp.showMessage('Xóa thành công');
        })
        .catch(_ => {
          window.getApp.showMessage('Xóa thất bại, vui lòng thử lại', 'error');
        });
    },
    openContextMenu (event, fence) {
      this.SET_SELECTED_GEOFENCE(fence);
      this.$refs.contextMenu.open(event);
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 128px);
  overflow: auto;
}
.menu-item-icon {
  font-size: 15pt;
  padding-right: 10px;
}
.purple--text {
  color: black !important;
  background: #fff8e3;
}
.v-context {
  width: 200px !important;
}
.on-top {
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/pages/geofence/components/List.vue